export default "__VITE_ASSET__CymQcY9t__"